import { useEffect, useState } from "react";
import "./ScrollToTop.scss";

const ScrollToTop = () => {
  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 150) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    });
  }, []);

  const goToTop = () =>
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

  return (
    showTopBtn && (
      <button
        className="scroll-button button-style"
        id="scroll-button"
        onClick={() => goToTop()}
      />
    )
  );
};

export default ScrollToTop;
